import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Products = React.lazy(() => import('./index'));
const ProductTable = React.lazy(() => import('./productTable'));
const Product = React.lazy(() => import('./product'));
const ProductDetail = React.lazy(() => import('./productDetail'));
const AddNewProduct = React.lazy(() => import('./addNewProduct'));
const EditProduct = React.lazy(() => import('./editProduct'));

export const useProductRoutes = () => {

    return (
        <Route path="products" element={<Suspense fallback={<div>منتظر باشید...</div>}><Products /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ProductTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewProduct/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Product/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ProductDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditProduct/></Suspense> } />
            </Route>
        </Route>
    )
}